import React from "react";
import { render } from "react-dom";
import * as serviceWorker from "./serviceWorker";
import App from "./App";
import "./assets/css/index.css";

import { createStore, applyMiddleware, compose } from "redux";
import rootReducer from "./redux/store/reducers/rootReducer";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { reduxFirestore, getFirestore } from "redux-firestore";
import { reactReduxFirebase, getFirebase } from "react-redux-firebase";
import fbConfig from "./config/firebase/fbConfig";

const store = createStore(
  rootReducer,
  compose(
    applyMiddleware(thunk.withExtraArgument({ getFirebase, getFirestore })),
    reactReduxFirebase(fbConfig, {
      userProfile: "users",
      useFirestoreForProfile: true,
      attachAuthIsReady: true
    }),
    reduxFirestore(fbConfig) // redux bindings for firestore
  )
);

const rootEl = document.getElementById("root");

let reactDOMrender = () => {
  store.firebaseAuthIsReady.then(() => {
    render(
      <Provider store={store}>
        <App />
      </Provider>,
      rootEl
    );
  });
};

if (module.hot) {
  module.hot.accept("./App", () => {
    setTimeout(reactDOMrender);
  });
}

reactDOMrender();

/* store.firebaseAuthIsReady.then(() => {
  render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById("root")
  );
}); */

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
